const LoadingScreen = () => {
    
    return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            {/* <p>Loading</p> */}
        </div>
    );     
}

export default LoadingScreen;